export default "__VITE_ASSET__6840180c__"